<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12 mb-2">
        <label for="statusTable">Pelaksanaan</label>
        <v-select
          :options="option_pelaksanaan"
          v-model="pelaksanaan"
          label="pelaksanaan"
          placeholder="Pilih Pelaksanaan"
          @search="searchPelaksanaan"
        >
        </v-select>
      </div>
      <div class="col-12">
        <ckeditor
          :editor="editor"
          v-model="editorData"
          :config="editorConfig"
        ></ckeditor>
      </div>
      <div class="col-12 mt-2">
        <button
          class="btn btn-primary btn-sm float-end"
          @click="saveInfo"
          v-if="isWrite || isWrite == 1"
        >
          <i class="fa fa-save me-1"></i> Simpan
        </button>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Informasi Ujian",
      isWrite: localStorage.getItem("isWrite"),
      idInfoUjian: this.$route.params.id,
      infoUjian: {},
      editor: ClassicEditor,
      editorData: "<p>Tambah informasi ujian disini.</p>",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "|",
          "outdent",
          "indent",
          "|",
          "blockQuote",
          "insertTable",
          "undo",
          "redo",
        ],
      },
      option_pelaksanaan: [],
      pelaksanaan: [],
    };
  },
  methods: {
    async getInfo() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "info-ujian/" +
          this.idInfoUjian,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => response.data.data);
      if (data) {
        this.editorData = data.info_ujian;
        this.infoUjian = data;
        this.pelaksanaan = data.jadwal_pelaksanaan;
        console.log(data.jadwal_pelaksanaan);
      }
    },
    async saveInfo() {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin menyimpan data Informasi Ujian ini ?",
        showCancelButton: true,
        confirmButtonText: "Ya, Saya yakin!",
        cancelButtonText: "Batal",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let method = this.idInfoUjian ? "put" : "post";
          let url = this.idInfoUjian
            ? `info-ujian/${this.idInfoUjian}`
            : `info-ujian`;
          let payload = {
            info_ujian: this.editorData,
            type: "peserta",
            idjadwal_pelaksanaan: this.pelaksanaan.idjadwal_pelaksanaan,
          };
          if (this.idInfoUjian) {
            payload.active_flag = this.infoUjian.active_flag;
          }

          const data = await axios({
            method: method,
            url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
            data: payload,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }).then((response) => response.data.data);
          if (data) {
            await Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil disimpan",
              timer: 2000,
              timerProgressBar: true,
            });
            this.$router.push({ name: "info-ujian" });
          }
        }
      });
    },
    searchPelaksanaan(loading, search) {
      loading(true);
      this.getFilterPelaksanaan(search, loading);
    },
    async getFilterPelaksanaan(search, loading) {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/jadwal-pelaksanaan/all",
        params: {
          search: search,
          limit: 50,
        },
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data.data)
        .catch((err) => {
          console.log("err get jadwal pelaksanaan", err);
          return false;
        });

      if (data) this.option_pelaksanaan = data;

      if (loading) loading(false);
    },
  },
  async mounted() {
    this.idInfoUjian = this.$route.params.id;
    if (this.idInfoUjian) {
      await this.getInfo();
    }
    await this.getFilterPelaksanaan("", false);
  },
};
</script>

<style></style>
